import React, { useState } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import LanguageSelectorModal from 'components/language-selector-modal';
import { useLocale } from 'state/intl';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import {
  LanguageSelectorButton,
  LanguageSelectorContainer,
  LanguageSelectorText,
} from './language-selector.styled';

const LanguageSelector = () => {
  const { formatMessage } = useIntl();
  const { language, readableLanguages, region } = useLocale();
  const [showLanguageSelectorModal, setShowLanguageSelectorModal] = useState(false);

  const onModalShow = () => {
    setShowLanguageSelectorModal(true);
  };

  const onModalDismiss = () => {
    setShowLanguageSelectorModal(false);
  };

  const formattedLanguage = `${readableLanguages[language]} (${region})`;

  return (
    <LanguageSelectorContainer testID="sign-up-language-selector">
      <LanguageSelectorButton
        accessibilityLabel={formatMessage({ id: 'languageAndRegionSelector' })}
        onPress={onModalShow}
      >
        <Icon variant="language" size="6" {...hiddenAccessibilityPlatformProps} />
        <LanguageSelectorText variant="headerFour" testID="formatted-language">
          {formattedLanguage}
        </LanguageSelectorText>
        <Icon variant="select" size="4" {...hiddenAccessibilityPlatformProps} />
      </LanguageSelectorButton>
      {showLanguageSelectorModal && (
        <LanguageSelectorModal onModalDismiss={onModalDismiss} redirectToCurrentLocation />
      )}
    </LanguageSelectorContainer>
  );
};

export default LanguageSelector;
